import { PaginationState } from "~/modules/filters/types";

// // // //

/**
 * Paginates an array of results in memory
 *
 * @template T - The type of elements in the results array.
 * @param {Array<T>} props.results - The array of results to be paginated.
 * @param {number} props.page - The current page number (1-based).
 * @param {number} props.perPage - The number of items per page.
 */
export function paginateItems<T>(props: {
    results: Array<T>;
    page: number;
    perPage: number;
}): {
    results: Array<T>;
    pagination: PaginationState;
} {
    const { results, page, perPage } = props;

    // Calculate the total number of results
    const resultCount = results.length;

    // Calculate the total number of pages
    const pageCount = Math.ceil(resultCount / perPage);

    // Calculate the starting index of the items for the given page
    const startIndex = (page - 1) * perPage;

    // Calculate the ending index (non-inclusive)
    const endIndex = startIndex + perPage;

    // Slice the results array to get the items for the current page
    const paginatedResults = results.slice(startIndex, endIndex);

    return {
        results: paginatedResults,
        pagination: {
            page,
            perPage,
            pageCount,
            resultCount,
        },
    };
}
